import type { GeneralConfig } from '@shared/types/Config';

export const ownerConfig: GeneralConfig = {
    sortFieldMap: {},
};
